import React, { Component } from 'react';
import { Provider } from 'react-message-source';
import { fetchMessages } from 'services/messageServices';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { RouterProps } from 'react-router';
import { withRouterWorkaround } from 'utils/workaroundUtils';

interface Props extends JSX.ElementChildrenAttribute, AuthConsumerRenderProps, RouterProps {}

interface State {
  [key: string]: string | {}
}

class AppBootstrap extends Component<Props, State> {

  state = {
    messages: {}
  };

  componentDidMount(): void {
    this.loadTextResources();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated && this.props.isAuthenticated) {
      this.loadTextResources();
    }

    if (prevProps.language !== this.props.language && (prevProps.isAuthenticated || !this.props.isAuthenticated)) {
      this.loadTextResources();
    }
  }

  loadTextResources = () => {

    const { setFetchingMessages, history } = this.props;

    setFetchingMessages(true);

    fetchMessages()
        .then(messages => this.setState({ messages }))
        .catch(() => {
          if (history.location.pathname != "/login") {
            history.push("/error");
          }
        })
        .finally(() => {
          setFetchingMessages(false);
        });
  };

  render() {
    return (
        <Provider value={this.state.messages}>
          {this.props.children}
        </Provider>
    );
  }
}

export default withRouterWorkaround(withAuthContext(AppBootstrap));
